export default __webpack_public_path__ + "static/media/diagram.5f87b0ad.png";